import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/functions";

const config = {
    apiKey: "AIzaSyAoAAze25wPo77rWlVweHXqHdv7d29KMB8",
    authDomain: "tubolegatan-1029b.firebaseapp.com",
    databaseURL: "https://tubolegatan-1029b-default-rtdb.firebaseio.com",
    projectId: "tubolegatan-1029b",
    storageBucket: "tubolegatan-1029b.appspot.com",
    messagingSenderId: "1048025026441",
    appId: "1:1048025026441:web:1608e13e1a40c2908f9b58",
    measurementId: "G-PQ16013CDD"
};

var fire = firebase.initializeApp(config);
export default fire;
